import { getDoc, doc } from 'firebase/firestore';
import { firestore } from '~/firebase/init';
import { Store, StoreWithId } from '~/types/store/store';

export default async function getStores(storesId: Array<string>): Promise<Array<StoreWithId>> {
  const res = await Promise.all(
    storesId.map((storeId) => {
      const ref = doc(firestore, `stores`, storeId);
      return getDoc(ref);
    }),
  );

  return res
    .filter((doc) => doc.exists())
    .map((doc) => {
      return { id: doc.id, ...(doc.data() as Store) };
    });
}
